/* RESPONSIBLE TEAM: team-ai-agent */
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

export const AgentType = {
  FIN: 'fin',
  FIN_SDR: 'fin_sdr',
  FIN_ECOMMERCE: 'fin_ecommerce',
} as const;

export type AgentTypeValue = (typeof AgentType)[keyof typeof AgentType];

interface AgentTypeConfigEntry {
  color: string;
  icon: InterfaceIconName;
  iconScale: string;
}

export const AGENT_TYPE_CONFIG: Record<AgentTypeValue, AgentTypeConfigEntry> = {
  [AgentType.FIN]: {
    color: '#E35712',
    icon: 'service-agent',
    iconScale: 'transform:scale(0.90)',
  },
  [AgentType.FIN_SDR]: {
    color: '#165FC6',
    icon: 'salesforce-case',
    iconScale: 'transform:scale(0.80)',
  },
  [AgentType.FIN_ECOMMERCE]: {
    color: '#0D7A3A',
    icon: 'shopping-cart',
    iconScale: 'transform:scale(0.85)',
  },
};

export const DEFAULT_AGENT_TYPE = AgentType.FIN;
